import router from '../router'
import firebase from '@/plugins/firebase'
import i18n from '@/main'
export default {
  state: {
    logeado: false,
    usuario: {
      rol: 'invitado'
    }
  },
  getters: {
    getUsuario: (state) => {
      return state.usuario
    },
    getRol: (state) => {
      return state.usuario.rol
    },
    getLogeado: (state) => {
      return state.logeado
    }
  },
  mutations: {
    setUsuario: (state, usuario) => {
      state.usuario = usuario
    },
    setLogeado: (state, estado) => {
      state.logeado = estado
    }
  },
  actions: {
    registroCliente: ({ commit }, usuario) => {
      firebase.auth().createUserWithEmailAndPassword(usuario.email, usuario.contrasena).then(respuesta => {
        var user = {
          uid: respuesta.user.uid,
          email: usuario.email,
          rol: 'cliente',
          nombre: usuario.nombre,
          newsletter: usuario.newsletter,
          favoritos: [],
          aprobado: true,
          revision: false
        }
        firebase.firestore().collection('usuarios').doc(user.uid).set(user).then(() => {
          commit('setUsuario', user)
          commit('setAlerta')
          commit('setTextoAlerta', 'Alerta.RegistroExitoso')
          if (router.currentRoute.path === '/acceso') {
            router.push(i18n.t('Alias.GeneralPerfil'))
          }
        })
      })
    },
    registroArtista: ({ commit }, usuario) => {
      firebase.auth().createUserWithEmailAndPassword(usuario.email, usuario.contrasena).then(respuesta => {
        var user = {
          uid: respuesta.user.uid,
          rol: 'artista',
          nombre: usuario.nombre,
          biografiaEs: usuario.biografiaEs,
          biografiaEn: '',
          pais: usuario.pais,
          departamento: usuario.departamento,
          ciudad: usuario.ciudad,
          direccion: usuario.direccion,
          email: usuario.email,
          telefono: usuario.telefono,
          categoria: usuario.categoria,
          redesSociales: usuario.redesSociales,
          tipoDocumento: usuario.tipoDocumento,
          numeroDocumento: usuario.numeroDocumento,
          nombreDeUsuario: usuario.nombreDeUsuario,
          fotoPerfil: '',
          favoritos: [],
          aprobado: false,
          revision: true,
          disabled: false,
          contratoSubido: false,
          certificadoBancarioSubido: false
        }
        firebase.firestore().collection('usuarios').doc(user.uid).set(user).then(() => {
          commit('setUsuario', user)
          commit('setAlerta')
          commit('setTextoAlerta', 'Alerta.RegistroExitoso')
          commit('setCargandoAccion', false)
          router.push(i18n.t('Alias.GeneralPerfil'))
        })
      })
        .catch(error => {
          commit('setAlerta')
          commit('setTextoAlerta', error.message)
        })
    },
    registroArtistaUpdate: ({ commit }, usuario) => {
      firebase.auth().createUserWithEmailAndPassword(usuario.email, usuario.contrasena).then(respuesta => {
        firebase.firestore().collection('usuarios').where('email', '==', usuario.email).get().then(info => {
          for (let i = 0; i < info.docs.length; i++) {
            var usuarios = []
            usuarios.push(info.docs[i].data())
          }
          firebase.firestore().collection('usuarios').doc(usuarios[0].uid).delete().then(() => {
            var user = {
              uid: respuesta.user.uid,
              rol: 'artista',
              nombre: usuario.nombre,
              biografiaEs: usuario.biografiaEs,
              biografiaEn: '',
              pais: usuario.pais,
              departamento: usuario.departamento,
              ciudad: usuario.ciudad,
              direccion: usuario.direccion,
              email: usuario.email,
              telefono: usuario.telefono,
              categoria: usuario.categoria,
              redesSociales: usuario.redesSociales,
              tipoDocumento: usuario.tipoDocumento,
              numeroDocumento: usuario.numeroDocumento,
              nombreDeUsuario: usuario.nombreDeUsuario,
              fotoPerfil: '',
              favoritos: [],
              aprobado: false,
              revision: true,
              disabled: false,
              contratoSubido: false,
              certificadoBancarioSubido: false
            }
            firebase.firestore().collection('usuarios').doc(user.uid).set(user).then(() => {
              commit('setUsuario', user)
              commit('setAlerta')
              commit('setTextoAlerta', 'Alerta.RegistroExitoso')
              commit('setCargandoAccion', false)
              router.push(i18n.t('Alias.GeneralPerfil'))
              console.log('usuario creado')
            })
          }).catch((error) => {
            commit('setAlerta')
            commit('setTextoAlerta', error.message)
          })
          // firebase.firestore().collection('usuarios').doc(usuarios[0].uid).update({
          //   uid: respuesta.user.uid,
          //   disabled: false
          // }).then(() => {
          //   var user = []
          //   firebase.firestore().collection('usuarios').doc(usuario.uid).get().then(info => {
          //     for (let i = 0; i < info.docs.length; i++) {
          //       this.user.push(info.docs[i].data())
          //     }
          //   })
          //   commit('setUsuario', user)
          //   commit('setAlerta')
          //   commit('setTextoAlerta', 'Alerta.RegistroExitoso')
          //   commit('setCargandoAccion', false)
          //   router.push(i18n.t('Alias.GeneralPerfil'))
          //   console.log('usuario habilitado')
          // }).catch((error) => {
          //   commit('setAlerta')
          //   commit('setTextoAlerta', error.message)
          // })
        }).catch((error) => {
          commit('setAlerta')
          commit('setTextoAlerta', error.message)
        })
      })
        .catch(error => {
          commit('setAlerta')
          commit('setTextoAlerta', error.message)
        })
    },
    iniciarSesion: ({ commit }, usuario) => {
      firebase.auth().signInWithEmailAndPassword(usuario.email, usuario.contrasena).then(respuesta => {
        firebase.firestore().collection('usuarios').doc(respuesta.user.uid).get().then(info => {
          commit('setUsuario', info.data())
          if (router.currentRoute.path === '/acceso') {
            router.push('/')
          }
          commit('setLogeado', true)
          commit('setAlerta')
          commit('setTextoAlerta', 'Alerta.IniciarSesion')
          // commit('setTotal')
        })
      })
        .catch(error => {
          commit('setAlerta')
          commit('setTextoAlerta', error)
        })
    },
    cerrarSesion: ({ commit }) => {
      const invitado = {
        rol: 'invitado'
      }
      firebase.auth().signOut().then(() => {
        commit('setUsuario', invitado)
        commit('setLogeado', false)
        commit('limpiarCarrito')
        localStorage.clear()
        router.push('/')
        commit('setAlerta')
        commit('setTextoAlerta', 'Alerta.SesionCerrada')
        commit('setTotal')
      })
    },
    eliminarDataUsuario: ({ commit }) => {
      const invitado = {
        rol: 'invitado'
      }
      firebase.auth().signOut().then(() => {
        commit('setUsuario', invitado)
        commit('setLogeado', false)
        commit('limpiarCarrito')
        localStorage.clear()
        router.push('/')
      })
    },
    eliminarUsuario: ({ commit, state }) => {
      firebase.storage().ref('usuarios').child(state.usuario.uid).listAll().then(files => {
        for (let i = 0; i < files.items.length; i++) {
          firebase.storage().ref().child(files.items[i].fullPath).delete()
        }
      })
      firebase.storage().ref().child('usuarios/' + state.usuario.uid)
      firebase.auth().currentUser.delete()
      firebase.firestore().collection('usuarios').doc(state.usuario.uid).delete().then(() => {
        const invitado = {
          rol: 'invitado'
        }
        commit('setUsuario', invitado)
        commit('setAlerta')
        commit('setTextoAlerta', 'Alerta.PerfilEliminado')
        router.push('/')
      })
    },
    recuperarContrasena: ({ commit }, email) => {
      firebase.auth().sendPasswordResetEmail(email).then(() => {
        commit('setAlerta')
        commit('setTextoAlerta', 'Alerta.ReestablecerContrasena')
      })
        .catch(error => {
          commit('setAlerta')
          commit('setTextoAlerta', error)
        })
    }
  }
}
